<!-- Start: Patients approved -->
<div class="tab-pane fade active show">

  <div *ngIf="!hasSearched && dataLoaded" class="search-prompt">
    <div class="search-prompt-card">
      <h2>Search for Approved Patients</h2>
      <div class="search-prompt-input">
        <input type="text" class="form-control" placeholder="Patient name, code, or keyword..."
          [(ngModel)]="searchTerm" (keydown)="onInlineSearchKeydown($event)" />
        <app-button type="button" variant="primary" text="Search" (clicked)="onInlineSearchClick()" />
      </div>
    </div>
  </div>

  <table class="std-results-list patients-approved" *ngIf="hasSearched">
    <tbody *ngIf="dataLoaded">
      <tr (click)="onPatientClicked(patient.patientTrialId)" *ngFor="let patient of results.results" data-toggle="link"
        data-toggle-class="more-btn">
        <td class="valign-top">
          <span class="label">{{ patient.patientCode == null ? 'NA' : patient.patientCode }}</span>

          <div class="patient-details">
            <span class="patient-name">{{ patient.getFullName() }}</span>
            <span class="patient-address">{{ patient.siteCountry }}</span>
          </div>
        </td>
        <td class="valign-top">
          <span class="label d-none d-lg-block">&nbsp;</span>
          <span class="patient-trial-name">{{ stringHelper.limit(patient.trialLabel, 45) }}</span>
        </td>
        <td class="result-btn text-right"><a class="btn btn-circle more-btn more-btn"
            routerLink="/patient/{{ patient.patientTrialId }}"><i aria-hidden="true" class="icon-right"></i></a>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!dataLoaded" class="approved-patients-loader">
      <tr *ngFor="let _ of loaderArray">
        <td class="loader-col-15">
          <ngx-skeleton-loader class="d-block patient-code-loader"></ngx-skeleton-loader>
          <ngx-skeleton-loader class="d-block"></ngx-skeleton-loader>
        </td>
        <td class="loader-col-40">
          <ngx-skeleton-loader class="d-block hidden-loader"></ngx-skeleton-loader>
          <ngx-skeleton-loader class="d-block loader-skeleton-narrow"></ngx-skeleton-loader>
        </td>
        <td class="loader-col-45">
          <ngx-skeleton-loader class="d-block hidden-loader"></ngx-skeleton-loader>
          <ngx-skeleton-loader class="d-block loader-skeleton-medium"></ngx-skeleton-loader>
        </td>
        <td><ngx-skeleton-loader appearance="circle" class="d-block loader-circle"></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
  </table>

  <app-pagination *ngIf="hasSearched" [currentPage]="results.currentPage" [totalPageCount]="results.totalPageCount"
    (pageSelected)="loadPatients($event, keywords, country, orderBy)"></app-pagination>

  <div class="no-results inside" *ngIf="hasSearched && !hasResults">
    <div class="inner">
      <div class="image">
        <img src="assets/img/no-patients.png" alt="No approved patients" />
      </div>
      <div class="content">
        <h2>No Approved Patients</h2>
      </div>
    </div>
  </div>

  <div class="no-results inside" *ngIf="hasSearched && results.results.length == 0 && hasResults">
    <div class="inner">
      <div class="image">
        <img src="assets/img/no-results-illustration.png" alt="No results found" />
      </div>
      <div class="content">
        <h2>No Results Found</h2>
        <p>There are no patients matching your search.</p>
      </div>
    </div>
  </div>

</div>
<!-- End: Patients approved -->
